export type Theme = 'sag' | 'shs';
export const THEME_TOKEN = 'theme' as const;
